import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import vueClickOutsideElement from 'vue-click-outside-element';

createApp(App).use(VueDatePicker).use(vueClickOutsideElement).use(store).use(router).mount('#app')

// Service Worker registratie voor betere performance
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
